export default __webpack_public_path__ + "static/media/RightChoice1.e491a7f5.jpg";